import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

export interface AdminEmailSearch {
  /** Deep-link: open the template editor — `new` to create, an id to edit. */
  template?: string;
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  validateSearch: (search: Record<string, unknown>): AdminEmailSearch => ({
    template: typeof search.template === "string" ? search.template : undefined,
  }),
  component: AdminEmailPage,
});
